module.exports = __webpack_public_path__ + "static/media/bu-plan.4b04c7ff.svg";